import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';
import { KpMenuApp } from './kp-menu-app';
import { MatIcon } from '@angular/material/icon';
import { MatMenuTrigger, MatMenu, MatMenuItem } from '@angular/material/menu';
import { MatIconButton } from '@angular/material/button';
import { NgIf, NgFor } from '@angular/common';

@Component({
  selector: 'kp-menu',
  templateUrl: './kp-menu.component.html',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgIf, MatIconButton, MatMenuTrigger, MatIcon, MatMenu, NgFor, MatMenuItem],
})
export class KpMenuComponent {
  @Input() apps?: KpMenuApp[] = [];
  @Input() workspaceBaseHref?: string;

  private readonly GAME_UP_ID = '85d8e4b9-9582-4c98-926d-9322e40896db';

  getAppHref(app: KpMenuApp) {
    if (this.workspaceBaseHref && app.id !== this.GAME_UP_ID) {
      return app.url.concat(this.workspaceBaseHref);
    }
    return app.url;
  }
}
